export const theme = {
  colors: {
    primary: '#FF6B6B', // Passionate red
    secondary: '#6B5B95', // Seductive purple
    accent: '#FF9999', // Soft pink
    background: '#1A1A2E', // Deep blue background
    backgroundLight: '#242444', // Lighter background for contrast
    text: '#F8F8F8', // Light text for dark backgrounds
    textSecondary: '#CCCCCC', // Secondary text color
    border: '#444466', // Border color
    success: '#4ECDC4', // Success color
    error: '#FF6B6B', // Error color
    warning: '#FFD166', // Warning color
  },
  fonts: {
    main: "'Montserrat', sans-serif",
    secondary: "'Lato', sans-serif",
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.2)',
    large: '0 8px 16px rgba(0, 0, 0, 0.3)',
  },
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
  gradients: {
    primary: 'linear-gradient(135deg, #FF6B6B 0%, #6B5B95 100%)',
    secondary: 'linear-gradient(135deg, #6B5B95 0%, #FF9999 100%)',
  },
}; 